(function () {
  if (window.__cardProductVideoInit) return;
  window.__cardProductVideoInit = true;

  var mql = window.matchMedia('(min-width: 990px)');

  var initialized = false;

  function init() {
    if (initialized) return;
    initialized = true;

    document.addEventListener('mouseover', function (e) {
      var card = e.target.closest('.card-wrapper');
      if (!card || card.contains(e.relatedTarget)) return;
      var video = card.querySelector('video.card__hover-video');
      if (video) video.play().catch(function () {});
    });

    document.addEventListener('mouseout', function (e) {
      var card = e.target.closest('.card-wrapper');
      if (!card || card.contains(e.relatedTarget)) return;
      var video = card.querySelector('video.card__hover-video');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    });
  }

  if (mql.matches) {
    init();
  } else {
    mql.addEventListener('change', function (e) {
      if (e.matches) init();
    });
  }
})();
